"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moduleEditUrl = void 0;
const constants_1 = require("configs/routes/constants");
const moduleEditUrl = ({ urlWithParams, isMembership, createModuleConceptEnabled, season, isPaidModule, isExtraModule, moduleId }) => {
    let url = `${constants_1.BASE_MODULE}/${moduleId}`;
    if (isMembership && createModuleConceptEnabled && isPaidModule) {
        url = `${constants_1.BASE_MODULE}/extra-paid/${moduleId}`;
        return urlWithParams(url, { extra: isExtraModule, season });
    }
    return urlWithParams(url, { extra: isExtraModule, season });
};
exports.moduleEditUrl = moduleEditUrl;
